import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import InboxTwoToneIcon from '@mui/icons-material/InboxTwoTone';
// import '@fontsource/roboto/300.css';
import Typography from '@mui/material/Typography';
import Style from './index.css';
export default (function (_a) {
    var children = _a.children;
    return _jsxs("div", { className: Style.container, children: [_jsx(InboxTwoToneIcon, { color: "warning", fontSize: "large" }), _jsx(Typography, { variant: "h6", component: "h2", children: children })] });
});
